module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Wade Coltrane stepped out of his truck and stared at the ranch house. Five years hadn’t changed much. The paint was a little more worn, flaking off in a few places. The lawn could use cutting and the barn out behind the house had that weathered, old-wood look, but other than that, it appeared the same.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tried to push back the feeling of having come home. He hadn’t returned to the Long K Ranch to get comfortable and reminisce about old times, or to pick up where he’d left off. In many ways you could never go back. Time had a way of changing people, places and perspective.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wade had come to secure employment with the ranch owner as cover for his real mission—spying on the one suspected of carrying out threats against Governor Lila Lockhart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Second thoughts about his task had no place in his life. After the disaster of his military career, he needed this job and he needed to redeem himself. If not to anyone else, then in his own mind. He had a lot to atone for and nothing and nobody would get in the way of that atonement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A pang of guilt sat like a wad of soggy sweat socks in his gut. Old Man Kemp had been his father’s employer, the grumpy ranch owner had been tough but, for the most part, fair.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Wade had grown up on the ranch, playing in the barn, riding ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("horses and swimming in the creek. Kemp’s granddaughter had tagged along, getting in his way almost every step of the way.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Being the boss’s kin, he’d put up with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An image of a redheaded hellion riding bareback at breakneck speeds across the pasture flashed across his memories.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay Kemp. Beautiful, passionate and fiercely independent and loyal. The boss’s granddaughter. Completely out of his league, only he hadn’t been bright enough to recognize it until too late.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sigh rose up his chest and he swallowed hard. History had no place in the present other than as a reminder not to repeat one’s mistakes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay had forgotten him as soon as he left for boot camp. By the time he’d built his career in the Army and returned to ask her to marry him, she’d up and gotten herself engaged to a local doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just as well that she married a doctor. She’d have hated the life of a military spouse. And he hadn’t been willing to give up his Army career. Then.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In five years, a lot could change.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wade knocked at the door. When no one answered, he rounded the house and headed for the barn. He spied movement in one of the training pens and altered his course.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A white-haired man, astride a sturdy bay gelding trotted around a well-worn circle inside the round pen. When he spied Wade, the old guy drew back on the reins, bringing the big gelding to a stop. Henry Kemp glared down at Wade with rheumy blue eyes. “We ain’t buying anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not selling.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re trespassin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m here to apply for the ranch hand job you posted at the Talk of the Town.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old man’s gaze traveled Wade’s length. “Why should I hire you?”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because I know this ranch as well as you do, Mr. Kemp.” Wade forced a grin he didn’t feel. “Do you remember me, Mr. Kemp? Wade Coltrane. Jackson Coltrane’s son.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Little Wade Coltrane?” Henry slung his leg over the horse and eased to the ground. For a seventy-five-year-old man, Mr. Kemp got around pretty good.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wade looked closer. The old guy got around but was it good enough to be a real threat to Governor Lockhart? This was the man suspected of hiring Rory Stockett to take a shot at her. The man who might have seeded the highway with horseshoe nails to cause the governor’s limo to crash late last night?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Granted the old guy was a perpetual grump, a loudmouth and generally cantankerous, and he loved his granddaughter. A big plus in Wade’s estimation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But if Bart Bellows had good reason to believe Henry Kemp was threatening Governor Lockhart, who was Wade Coltrane, ex-soldier, to argue? He needed the job Bart offered, not only for the money, but also for a second chance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henry’s eyes narrowed. “Why you hiding behind that beard?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wade rubbed the neatly trimmed facial hair. “Not hiding. The ladies tell me it’s sexy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old man snorted. “That flyer must be three months old. I hired a ranch hand a long time ago. What do I need another one for?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hear you’ve got some fences in need of repairing and roundup next week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And some people have big mouths. Where’d you learn all that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wade reached out to stroke the soft muzzle of the gelding. “A couple of mutual acquaintances.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d bet my Sunday shorts that was Stan and Fred. Those old coots ain’t got a lick of sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So…do you?”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kemp’s bushy white brows rose. “Do I what? Have a lick of sense? Hell, yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wade chuckled. “I know that, but do you have a need for a ranch hand who knows what he’s doing and knows the lay of the land?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I tell you what I don’t need, and that’s a smart-mouth cowboy. Have you learned any better how to take orders?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take ’em, and give ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old man glared down at him for a full minute before he spoke again. “You can have a rack in the bunkhouse. Dinner’s at the big house at six-thirty sharp. If you’re not there, you don’t eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a tip of his hat, Wade stood with his foot on the lower fence rail. “Thanks, Mr. Kemp.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t thank me. And don’t make me regret hiring you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old man had walked right into Wade’s trap, believing his story hook, line and sinker. The first step in his infiltration was successful, Wade walked away, his sights set on mission accomplishment. Nothing would get in his way.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("INDSAY")]), _vm._v(" K"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EMP STEERED")]), _vm._v(" the rickety ranch truck through the arching gateway of the Long K Ranch. Lyric and Lacey leaned against each other in the backseat of the crew cab, buckled into their booster seats, sound asleep. They usually fell asleep on the way home from the Cradles to Crayons Daycare where they spent two days of the week in the mother’s day-out program. Lindsay couldn’t really afford it, but the girls needed time to play with children their own age. And Lindsay needed the break to handle things in town and on the ranch without four-year-old, identical twins underfoot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced in the rearview mirror at the black-haired girls and marveled at how they didn’t look a bit like her. Neither child had auburn hair, gray-green eyes or even a single freckle like their mother.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their biological father had strong genes. He’d been the spitting image of his father, thick black hair, blue eyes and high cheekbones. Somewhere in their ancestry was Apache Indian blood, thus the hair and cheekbones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Too bad the girls would never know their father and their father would never know them. Because he’d dedicated himself to a career in the Army, Lindsay hadn’t wanted to place a burden on him by telling him that she was pregnant. Almost five years later, the opportunity to enlighten him was well past.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay glanced at her watch. Crap!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had exactly ten minutes to get the girls into the house, get herself changed and catch the horses before Zachary showed up for his riding lesson. Stacy, Zachary’s mother, always arrived five minutes early.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay pressed her foot to the accelerator, roaring down the gravel road toward the ranch house. She skidded to a stop in front of the only home she’d ever known, slammed the truck into Park and jumped out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Girls, let’s get you inside. Come on. Wake up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lacey perked up and stared around, her eyes blinking. “Can I have a grilled cheese sandwich?” Lindsay lifted her out of the truck and set her on her feet")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe after riding lessons, unless Grandpa can make it for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lacey trudged toward the house, her forehead wrinkled in a frown. “He burns them. I want you to make me one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then it’ll have to wait until after lessons.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lyric remained fast asleep on the backseat, having tipped over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her pale skin and bright pink lips looked angelic. Lindsay didn’t have the heart to wake her. Despite her aching back, she lifted the child and carried her into the house where she laid her on the couch in the living room.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gramps,” Lindsay shouted, hurrying down the hallway to her room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That you, Lindsay?” a coarse voice called from the study.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir. I’m late for my riding lessons. Can I bother you to keep an eye on the girls?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bother?” Her grandfather appeared in the doorway to his office. “Since when are my great-granddaughters a bother?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a dream, Gramps.” Lindsay ducked into her room and yanked a well-worn chambray shirt and equally worn jeans from her closet. “Lacey wants a grilled cheese sandwich. She can wait until I get done with lessons.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m old, not dead. I can manage a little girl’s sandwich,” her grandfather groused.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay had learned long ago that Grandpa Kemp’s bark was much worse than his bite. Even the twins had him figured out. Too bad not everyone in Freedom, Texas, understood Henry Kemp. He griped fiercely, and he loved fiercely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gramps, she doesn’t like it burned. Give her a drink and an apple. I’ll make the sandwich when I’m done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m perfectly capable of making a sandwich,” he grumbled. “But have it your way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, Gramps.” Lindsay smiled inside her room, slipping out of her nicest jeans and into worn denim. After lessons, she’d be mucking stalls. No use damaging her only good pair of jeans. “They can come out when they’re fully awake and have had their snack.” Lindsay stripped her best white blouse off and shoved her arms into the chambray shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, ma’am. Am I getting that old that I’m taking orders from my granddaughter now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay buttoned as she hurried down the hall. She stopped to briefly kiss her grandfather’s cheek. “You’re always the boss, Gramps. I love you.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old man rubbed a hand to the place she’d kissed, a frown clearing from his forehead. “Damn, right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Watch your language.” Lindsay sprinted through the house, grabbing sugar cubes from the jar on the table beside the back door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hired a new ranch hand today,” her grandfather called out behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay stumbled. What? She didn’t have time to stop and go back to question him. A new ranch hand? They couldn’t afford to pay the hands they had. The weight of the world bore down on her shoulders. How could she get it through her grandfather’s head that they didn’t have any money?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d just have to apologize to the new hand and send him packing before he put in too many hours. Easy enough. Dealing with her grandfather was an entirely different challenge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For now she needed to focus on the only lucrative business on the place. The riding lessons, which had started as a way to make a little extra income for her and the girls, had grown into a financial supplement for the ranch. Until they brought in the herd and sent them off to auction, they were pretty well broke. The riding school put food on the table for Lindsay’s family and the ranch hands until cash flow improved.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An SUV pulled to a halt in front of the barn. Stacy Giordano climbed down and waved at Lindsay. “Hey, girl, sorry I’m late. It’s been insane at the governor’s place.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi, Stacy.” Lindsay hurried toward Stacy. “I’m running late, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you hear about the governor’s accident last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay ground to a halt in front of the vehicle, her stomach flip-flopping. “Accident?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, I spent my day at the hospital with the governor, her bodyguards and her driver.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Holy smokes. What happened?”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not sure yet, but they think someone threw nails all over the road. Two of the tires blew and sent them into a ditch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is everyone all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stacy nodded. “Mostly minor injuries, but the driver suffered a concussion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Any idea who might have done it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not yet. The sheriff is checking into it. In the meantime, we’ve had to tighten security even more. Much tighter and we won’t be able to breathe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry to hear that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stacy opened the back door to her SUV and helped her son down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, Zachary, good to see you.” Lindsay turned toward the barn. “You guys wait just a minute while I catch Whiskers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can wait, but Zachary will be chomping at the bit to ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay smiled and waved at Zachary as she passed by. “Let him stand by the fence while I get a bridle.” She stopped again, dug in her pocket and turned to the boy. “Here, you can help me. Hold out your hand with this and Whiskers will come to you.” She pressed a sugar cube into the boy’s hand and curled his fingers around it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Zachary stared at his closed hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on, Zachary. Let’s go see if Whiskers will come to you.” Stacy took his other hand and led him toward the wood-rail fence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay raced into the barn grabbing a bridle from the nail on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A movement in the shadows made her jump.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frank Dorian pushed away from the wall he’d been leaning on, a pitchfork in his hand, the stall beside him open and untouched.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you supposed to be cleaning the stalls?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frank shrugged. “Maybe.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anger flared and Lindsay came to a complete halt in front of the big cowboy her grandfather had hired several weeks ago. He had issues taking orders from a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay didn’t have issues with calling him on it. “Either you are or you aren’t. Which is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man stepped up to her and looked down his nose into her eyes. “I can think of a lot more interesting things to do in a barn than mucking stalls.” He reached out and trailed his finger down her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay knocked his hand away, rage burning a path up her chest into her cheeks. “Don’t. Ever. Touch me again.” She glared at him, her lips pressed tightly together. “Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped closer, his chest pushing against hers. “Or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart hammering behind her rib cage, Lindsay refused to step back, refused to back down. “Or I’ll have your butt fired so fast you won’t know what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your grandfather hired me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I’m telling you, I can fire you.” She narrowed her eyes at him. “Care to test the theory?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frank leaned down, his lips next to her ear. “Just so you know, no one fires Frank Dorian.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A shadow blocked the sun streaming in through the barn’s open double doors. “Is there a problem here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The low, resonant voice raised gooseflesh along Lindsay’s arms. If she wasn’t so distracted by Frank, she’d swear the voice was familiar. Only one man she’d ever known had the ability to make her shiver all over. “Is there a problem, Frank?” Lindsay asked the man who’d just threatened her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No problem.” Frank stepped away from Lindsay and entered the dirty stall, pitchfork in hand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("As soon as he moved, a broad-chested man came into view. ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("With his back to the outside door, his face remained in the shadows.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can I help you?” Lindsay asked, moving closer, the hairs on the back of her neck standing at attention, her knees suddenly wobbly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought maybe I could help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That voice again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lindsay clutched the bridle with nerveless fingers, all the blood draining from her face. It couldn’t be. Not now. Not him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As though dragged by an invisible rope, she moved closer until she could see the man’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gasped, her hand going to her throat and then reaching out toward him. He had to be a mirage. “Wade?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man with ice-blue eyes and coal-black hair nodded. “Hello, Ms. Kemp. Or should I say Mrs. Murphy?”")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6502ae5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459205987_ch01.vue
// module id = 81
// module chunks = 0